import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ManualEntryDatePicker from '../../../clock/ManualEntry/ManualEntryDatePicker';
import { isNullOrUndefined } from '../../../helpers/helpers';
import { DateTime } from 'luxon';

const resolveCustomDateLink = ({
  col,
  responses = {},
} = {}) => {
  const zone = DateTime.local().zoneName;
  if (col?.dateLinkType === 'currentDate') {
    return DateTime.now().setZone(zone).toSQLDate();
  }
  if (col?.dateLinkType === 'dateTime' && col?.linkedDateTimeFieldId) {
    const {
      [col.linkedDateTimeFieldId]: {
        date,
        timezone: fieldTimezone,
      } = {},
    } = responses;
    if (!date) return null;
    return DateTime.fromMillis(date).setZone(fieldTimezone ?? zone).toSQLDate();
  }
  return null;
};

export default function CustomDateColumn({
  col,
  value,
  record,
  onChange,
  isReadOnly,
  responses = {},
}) {
  const linkedValue = resolveCustomDateLink({ col, responses });

  useEffect(() => {
    if (isReadOnly || !isNullOrUndefined(value) || !linkedValue) return;
    onChange(record, linkedValue);
  }, [linkedValue, value, isReadOnly, onChange, record]);

  if (isReadOnly) return value ?? '';

  return (
    <ManualEntryDatePicker
      value={value || undefined}
      onChange={(newDate) => onChange(record, newDate ?? '')}
      allowFuture
      allowClear
    />
  );
}

CustomDateColumn.propTypes = {
  col: PropTypes.shape({}).isRequired,
  value: PropTypes.string,
  record: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  responses: PropTypes.shape({}),
};

CustomDateColumn.defaultProps = {
  value: undefined,
  record: {},
  isReadOnly: false,
  responses: {},
};
